// @flow
import { takeEvery, put } from 'redux-saga/effects';

import { getArrayResource } from '@redux/components/ApiRequest/actions';
import {
  DOCUMENTS_FORM_CREATED,
  DOCUMENTS_FORM_DELETED,
  DOCUMENTS_FORM_UPDATED
} from '@screens/Profile/ProfileDocuments/DocumentsUpload/redux/constants';
import { mainApiUrl } from '@lib';

import { DOCUMENTS_CERTIFICATES_REQUEST } from './constants';

import { updateDocumentsCertificates, errorDocumentsCertificates } from './actions';

export function* documentsCertificatesRequestFlow(): Generator<Function, void, void> {
  yield put(
    getArrayResource(
      `${mainApiUrl}/v1/patient_files`,
      updateDocumentsCertificates,
      errorDocumentsCertificates
    )
  );
}

function* documentsCertificatesWatcher(): Generator<Function, void, void> {
  yield takeEvery(
    [
      DOCUMENTS_CERTIFICATES_REQUEST,
      DOCUMENTS_FORM_CREATED,
      DOCUMENTS_FORM_DELETED,
      DOCUMENTS_FORM_UPDATED
    ],
    documentsCertificatesRequestFlow
  );
}

export default documentsCertificatesWatcher;
